export const DOMAIN_NAME = 'OutputView'
export const DASGBOARDNOW_PAGE = `${DOMAIN_NAME}.DashboardNowcasting`
export const TITLE = `${DASGBOARDNOW_PAGE}.TITLE`

export const MULTI_SELECT = `${DASGBOARDNOW_PAGE}.MultiSelect`

export const MULTI_SELECT_CONFIG = {
  LABEL: `${MULTI_SELECT}.LABEL`,
  TITLE: `${MULTI_SELECT}.TITLE`
}

export const multiSelectItems = [
  {
    id: 0,
    text: `${MULTI_SELECT}.Items.VALUE`,
    symbol: 'm€'
  },
  {
    id: 1,
    text: `${MULTI_SELECT}.Items.PERCENTAGE`,
    symbol: '%'
  },
  {
    id: 2,
    text: `${MULTI_SELECT}.Items.PIECES`,
    symbol: 'pz'
  },
  {
    id: 3,
    text: `${MULTI_SELECT}.Items.ARTICLES`,
    symbol: 'art'
  }
]
export const intialMultiSelectItems = [
  {
    id: 0,
    text: `${MULTI_SELECT}.Items.VALUE`,
    symbol: 'm€'
  },
  {
    id: 2,
    text: `${MULTI_SELECT}.Items.PIECES`,
    symbol: 'pz'
  },
  {
    id: 3,
    text: `${MULTI_SELECT}.Items.ARTICLES`,
    symbol: 'art'
  }
]

const BUTTONS = `${DASGBOARDNOW_PAGE}.Buttons`

export const Buttons = {
  PULL: `${BUTTONS}.PULL`,
  PUSH: `${BUTTONS}.PUSH`,
  PUSH_ESTREMO: `${BUTTONS}.PUSH_ESTREMO`
}

export const DASGBOARDNOW_SECTION = `${DASGBOARDNOW_PAGE}.Section`
